import { Fragment } from 'react';

import DataGrid from '@/components/elements/lists/DataGrid';
import { _t } from '@/locale';
import { CheckoutDetailsBundle } from '@/types/checkout';

type Props = {
  baseTranslationKey:
    | 'components.modules.checkout.CheckoutDetails'
    | 'components.modules.appointment.AppointmentDetailsSummary';
  bundles?: CheckoutDetailsBundle[];
};

const PaymentDetailsBundlesList = ({ baseTranslationKey, bundles }: Props) => {
  if (!bundles || bundles.length === 0) {
    return null;
  }

  return (
    <>
      {bundles?.map(({ name, price, quantity, validity, discount }, key) => {
        return (
          <Fragment key={name + key}>
            <DataGrid.Row key={key} hasPaddingTop>
              <DataGrid.Cell
                title={name}
                type="default"
                ariaLabel={_t(`${baseTranslationKey}.ariaLabel.service.name`)}
                truncate
              />
              <DataGrid.Cell
                title={discount ? <span className="text-fg_highlight">{discount}</span> : price}
                align="right"
                ariaLabel={_t(`${baseTranslationKey}.ariaLabel.service.price`)}
                nowrap
              />
            </DataGrid.Row>
            <DataGrid.Row>
              <DataGrid.Cell
                title={quantity}
                type="description"
                ariaLabel={_t(`${baseTranslationKey}.ariaLabel.service.price`)}
              />
              {discount && (
                <DataGrid.Cell
                  title={<span className="text-fg_secondary line-through">{price}</span>}
                  type="description"
                  ariaLabel={_t(`${baseTranslationKey}.ariaLabel.service.price`)}
                  align="right"
                />
              )}
            </DataGrid.Row>
            {validity && (
              <DataGrid.Row underline>
                <DataGrid.Cell
                  title={validity}
                  type="description"
                  ariaLabel={_t(`${baseTranslationKey}.ariaLabel.service.duration`)}
                />
              </DataGrid.Row>
            )}
          </Fragment>
        );
      })}
    </>
  );
};

export default PaymentDetailsBundlesList;
